export default () => {
  self.onmessage = (message) => {
    const arraySum = message.data.reduce((a:number, value:number) => a + value, 0);
    const average = arraySum / message.data.length;
    let percentage = (average / 255) * 100;
    percentage = percentage < 0.1 ? 0 : percentage;
    postMessage(percentage);
  };
};
